import { render, staticRenderFns } from "./StandardDeviation.vue?vue&type=template&id=13083426&"
import script from "./StandardDeviation.vue?vue&type=script&lang=js&"
export * from "./StandardDeviation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports